module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\"><path fill=\"currentColor\" d=\"M3.58 5.95a2 2 0 1 1 1.25-.13C5.29 7.67 6.52 8.37 8 8.37s2.7-.7 3.17-2.55a2 2 0 1 1 1.25.13c-.52 2.32-2 3.44-3.8 3.64v1.51a2 2 0 1 1-1.24 0V9.59c-1.8-.2-3.28-1.32-3.8-3.64zM12 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-4 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM4 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/components/ui/icons/svg/icon-fork-small.svg
// module id = 913
// module chunks = 0